if (!customElements.get('tooltip-info')) {
  customElements.define(
    'tooltip-info',
    class TooltipInfo extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.tooltip__trigger');
        this.content = this.querySelector('.tooltip__content');
        this.closeButton = this.querySelector('.js-tooltip-close');

        if (!this.trigger || !this.content) return;

        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.trigger.addEventListener('click', this.toggle.bind(this));
        this.closeButton?.addEventListener('click', () => {
          this.close();
          this.trigger.focus();
        });
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') this.close();
        });
        this.addEventListener('focusout', this.onFocusOut.bind(this));

        // Opt-in hover, and only where a real pointer exists. Touch devices keep
        // the click behaviour, since emulated hover would open on first tap.
        if (this.hasAttribute('data-hover') && window.matchMedia('(hover: hover)').matches) {
          this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
          this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
          this.addEventListener('focusin', this.onFocusIn.bind(this));
        }
      }

      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      toggle(event) {
        event.preventDefault();
        this.isOpen ? this.close() : this.open();
      }

      open() {
        clearTimeout(this.closeTimer);
        this.trigger.setAttribute('aria-expanded', 'true');
        this.content.removeAttribute('hidden');
        document.addEventListener('click', this.onDocumentClick);
      }

      close() {
        clearTimeout(this.closeTimer);
        this.trigger.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('hidden', '');
        document.removeEventListener('click', this.onDocumentClick);
      }

      onMouseEnter() {
        this.open();
      }

      /**
       * Closes after a short delay, so the pointer can travel from the icon to
       * the popover without it vanishing (WCAG 1.4.13, "hoverable").
       */
      onMouseLeave() {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.close(), 150);
      }

      /**
       * Opens on keyboard focus only. A mouse click also focuses the trigger,
       * and opening here would let the click handler immediately toggle it shut.
       */
      onFocusIn() {
        let isKeyboardFocus = false;
        try {
          isKeyboardFocus = this.trigger.matches(':focus-visible');
        } catch (error) {
          isKeyboardFocus = false;
        }
        if (isKeyboardFocus) this.open();
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.close();
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }
    }
  );
}
